import React from 'react';
import { useSelector } from 'react-redux';

import EmptyListing from 'src/components/EmptyListing/EmptyListing';
import 'src/components/EmptyListing/AgreementMissing.scss';

import FileLock from '@mdi/svg/svg/file-lock.svg';
import ArrowRight from '@mdi/svg/svg/arrow-right.svg';


const AgreementMissing = () => {
  const settingsURL = useSelector(({ configReducer }) => configReducer.settingsURL);

  const { titleText, hintText } = {
    titleText: 'Włącz zgodę w ustawieniach',
    hintText: 'i zobacz oferty pracy dopasowane do Ciebie'
  };

  return (
    <EmptyListing
      copy={ (
        <p styleName="copy">
          <span styleName="copy__anchor">
            { titleText }
          </span>
          {' '}
          { hintText }
          <ArrowRight className="arrow-right" viewBox="0 0 24 24" />
        </p>
) }
      dataTest="anchor-profilingAgreement"
      header="Brak zgody na profilowanie"
      icon={ FileLock }
      link={ settingsURL }
    />
  );
};


export default AgreementMissing;
